/*
 * The main JavaScript file for the child theme.
 */



/**
 * Module imports.
 */

import { Theming } from "./theming/theming.js";



/**
 * Runtime.
 */

// Add our own functionality
window.app.init.wisesiteChild =
{
}

// Boot up the app. You may delete parent theme functions by using the following code: `delete window.app.wisesite.init.yourFuncHere;`. You may then replace them with your own functionality like: `window.app.wisesiteChild.init = () => { stuff stuff stuff };`.
Theming.initApp();
